module.exports = __webpack_public_path__ + "static/img/Smart DBS.dc59851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/dashboard/Smart DBS.png
// module id = GiGw
// module chunks = 8